<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { rSplitArray } from '@/utils'
import cartMessages from '@/components/cart-messages'

export default {
  name: 'cart-items',
  data () {
    return {
      showMessagesPanel: false,
      msgOrder: 'Wysłać zamówienie do realizacji? Do zamówienia zostaną doliczone koszty transportu (zwykle 14-49zł) ' +
        'w zależności od rodzaju zakupionych produktów. Koszt będzie widoczny po potwierdzeniu zamówienia przez naszego ' +
        'pracownika.'
    }
  },
  components: {
    'cart-messages': cartMessages
  },
  computed: {
    ...mapGetters([ 'getCartId' ]),
    ...mapState([
      'cart',
      'cartItems',
      'cartStatuses',
      'compoundsMap'
    ])
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (vm.getCartId && !vm.cart.created) {
        vm.aFetchCart()
      }
      vm.aFetchCartItems()
    })
  },
  beforeRouteUpdate (to, from, next) {
    this.aFetchCartItems()
    this.aFetchCart()
      .then(() => next())
  },
  methods: {
    ...mapActions([
      'aDeleteCart',
      'aFetchCart',
      'aFetchCartItems',
      'aSetCartStatus',
      'aChangeCartAmount',
      'aDownloadCartOffer',
      'aMessageDisplay'
    ]),
    cartSummary (params) {
      return [
        'Razem',
        null,
        this.$options.filters.format_price(this.cart.price),
        this.$options.filters.format_item_amount(this.cart.itemCount) + ' poz.'
      ]
    },
    checkStatus (statusList) {
      return statusList.includes(this.cart.status)
    },
    changeCartAmount (row) {
      this.aChangeCartAmount({
        priceList: row.priceList.id,
        amount: row.amount
      })
    },
    itemsPrice (price, amount) {
      return price * amount
    },
    handleStatus (status, message) {
      if (!message) {
        message = status
      }
      this.$confirm(message, '', {
        confirmButtonText: 'Wyślij',
        cancelButtonText: 'Wróć do edycji zamówienia',
        type: 'info'
      }).then(() => {
        this.aSetCartStatus(status)
      })
    },
    handleReject () {
      this.$confirm(
        'Oferta zaostanie oznaczona jako odrzucona, a zamówienie zamknięte. Będziemy wdzięczni za ' +
        'wysłanie wiadomości z informacją o przyczynach odrzucenia oferty. Czy na pewno chcesz kontunuować?',
        'Uwaga',
        {
          confirmButtonText: 'Tak',
          cancelButtonText: 'Nie',
          type: 'error'
        }).then(() => {
          this.aSetCartStatus('reject')
        })
    },
    handleCancel () {
      this.$confirm('Ta operacja spowoduje bezpowrotne usunęcie koszyka. Czy na pewno chcesz kontunuować?', 'Uwaga', {
        confirmButtonText: 'Tak',
        cancelButtonText: 'Nie',
        type: 'error'
      }).then(() => {
        this.aDeleteCart()
          .then(() => {
            this.aMessageDisplay('cart-deleted')
            this.$router.push({ name: 'compounds' })
          }).catch(() => { })
      })
    },
    handleCloseMessagesPanel (done) {
      done()
    },
    getActiveStatusIdx () {
      if (this.cart.statuses) {
        return this.cart.statuses.length
      }
      return 0
    },
    getCartStatuses () {
      let cartStatuses = this.cartStatuses
      let states = [ cartStatuses[ 'opened' ] ]
      let stdFlow = [ 'requested', 'confirmed', 'collected', 'sent', 'completed' ]
      let statuses = (this.cart.statuses.slice(0) || []).reverse()

      statuses.forEach((status, index) => {
        if (cartStatuses[ status.state ]) {
          states.push(cartStatuses[ status.state ])
        } else {
          states.push({ label: status.state })
        }
        stdFlow = rSplitArray(stdFlow, status.state)
      })

      stdFlow.forEach((state, index) => {
        states.push(cartStatuses[ state ])
      })

      return states
    },
    getRowClassName (row) {
      return row.row.priceList && row.row.priceList.compound.isAvailable ? '' : 'disabled'
    }
  }
}
</script>

<style lang="sass">
.header

  .el-button
    width: 14rem
    margin: .5rem;
</style>

<template>
  <el-main>
    <el-row
      :gutter="20"
      class="header"
    >
      <el-col
        :offset="0"
        :md="12"
        :sm="24"
        v-if="getCartId"
      >
        <h1>Zamówienie {{cart.name}} ({{ getCartId.slice(0,4) }})</h1>
        <h3>
          utworzone: {{ cart.created | format_datetime }}<br>
          <span v-if="cart.requestDate">wysłane do realizacji: {{ cart.requestDate | format_datetime }} <br></span>
          na kwotę: {{ cart.price | format_price }}
        </h3>
      </el-col>
      <el-col
        :offset="0"
        :md="12"
        :sm="24"
        v-if="!getCartId"
      >
        <h2>Koszyk obecnie jest pusty.</h2>
      </el-col>
      <el-col
        :md="6"
        :sm="24"
        :key="this.cart.status"
        v-if="getCartId"
        style="margin-bottom: 1rem;"
      >
        <el-button
          icon="el-icon-circle-check"
          type="primary"
          v-if="checkStatus(['opened'])"
          @click="handleStatus('order', msgOrder)"
        >Zamów</el-button><br>
        <el-button
          icon="el-icon-question"
          type="primary"
          plain
          v-if="checkStatus(['opened'])"
          @click="handleStatus('offer', 'Proszę o przygotowanie oferty cenowej.')"
        >Zapytanie ofertowe</el-button>
        <el-button
          icon="el-icon-circle-check"
          type="primary"
          v-if="checkStatus(['offered'])"
          @click="handleStatus('order', 'Akceptuję przedstawioną ofertę i proszę o realizację zamówienia.')"
        >Zatwierdź ofertę</el-button>
        <el-button
          icon="el-icon-document"
          plain
          type="primary"
          v-if="checkStatus(['offered'])"
          @click="aDownloadCartOffer()"
        >Pobierz ofertę w PDF</el-button>
        <el-button
          icon="el-icon-circle-close"
          plain
          v-if="checkStatus(['offered'])"
          @click="handleReject"
        >Odrzuć ofertę</el-button>
        <el-button
          icon="el-icon-circle-close"
          plain
          v-if="checkStatus(['opened', 'offer'])"
          @click="handleCancel"
        >Anuluj</el-button>
        <el-button
          type="info"
          icon="el-icon-chat-line-round"
          plain
          @click="showMessagesPanel = true"
        >Korespondencja</el-button>
      </el-col>
      <el-col
        :md="6"
        :sm="24"
        v-if="getCartId"
      >
        <el-steps
          :active="getActiveStatusIdx()"
          align-center
          direction="vertical"
          finish-status="success"
        >
          <el-step
            v-for="status in getCartStatuses()"
            :key="status.state"
            :title="status.label"
            :description="status.description"
          ></el-step>
        </el-steps>
      </el-col>
    </el-row>

    <el-table
      :data="cartItems"
      :row-class-name="getRowClassName"
      :summary-method="cartSummary"
      ref="cartItemsTable"
      show-summary
    >
      <el-table-column label="Nazwa">
        <template slot-scope="props">
          <el-row>
            <el-col>
              {{ props.row.name }}
            </el-col>
            <el-col v-if="props.row.priceList">{{ props.row.priceList.compound.formula }}</el-col>
          </el-row>
        </template>
      </el-table-column>
      <el-table-column
        label="Opakowanie"
        align="right"
        width="150"
      >
        <template slot-scope="props">
          {{ props.row.amountPerUnit | format_item_amount }}&nbsp;
          {{ compoundsMap.units[props.row.unit].short || '-' }}
        </template>
      </el-table-column>
      <el-table-column
        label="Cena"
        width="150"
        align="right"
      >
        <template slot-scope="props">
          {{ props.row.price | format_price }}<br>
          <small>{{ itemsPrice(props.row.price, props.row.amount) | format_price }}</small>
        </template>
      </el-table-column>
      <el-table-column
        align="right"
        width="150"
      >
        <template slot="header">
          <i class="fa fa-cart-plus"></i>
        </template>
        <template slot-scope="scope">
          <el-input-number
            align="right"
            controls-position="right"
            placeholder="0"
            size="mini"
            v-if="checkStatus(['opened']) && scope.row.priceList && scope.row.priceList.compound.isAvailable"
            v-model="scope.row.amount"
            :min=0
            @change="changeCartAmount(scope.row)"
          ></el-input-number>
          <span v-else>{{ scope.row.amount | format_item_amount }}</span>

        </template>
      </el-table-column>
    </el-table>
    <el-drawer
      direction="rtl"
      size="50%"
      :destroy-on-close="true"
      :before-close="handleCloseMessagesPanel"
      :visible.sync="showMessagesPanel"
      custom-class="intouch"
    >
      <h2 slot="title">Korespondencja do zamówienia {{ getCartId.slice(0,4) }}</h2>
      <cart-messages></cart-messages>
    </el-drawer>
  </el-main>
</template>



// WEBPACK FOOTER //
// src/components/cart.vue